<!--
 * @Author: zhaoliang
 * @Date: 2024-08-24 13:03:06
 * @LastEditTime: 2026-01-23 11:26:43
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/BaseUi/ProductDetailsCards/PDFModal.vue
 *
-->
<template>
  <div
    class="modal-mask"
    v-if="open"
    ref="modalMask"
    :style="{ minHeight: this.minHeight, boxSizing: 'border-box' }"
  >
    <div class="modal-containner">
      <div class="modal-header">
        <img class="modal-close" @click="handleVisable(false)" src="~img/back.png" alt="cancel" />
        <div class="modal-footer">
          <button class="modal-print-btn" @click="handlePrint">{{ $t('mbs-email-print') }}</button>
          <button class="modal-download-btn" @click="handleDownload" @touchend="handleDownload">
            <img src="~img/icon-download.svg" alt="download" />
            <span>{{ $t('mbs-email-download') }}</span>
          </button>
        </div>
      </div>
      <div class="modal-content">
        <div class="pdf-wrap">
          <div class="pdf">
            <!-- <pdf ref="pdf" :src="url"></pdf> -->
            <pdf ref="pdf" :pdfUrl="pdfUrl"></pdf>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import pdf from '@/components/PDFViewer/index.vue';
  export default {
    name: 'Modal',
    components: {
      pdf,
    },
    computed: {},
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      pdfUrl: {
        type: Blob,
        default: new Blob(),
      },
    },
    data() {
      return {
        url: {},
        downloadPdfUrl: {},
        minHeight: '0px',
      };
    },
    created() {},
    mounted() {
      this.minHeight = `${
        document.documentElement.clientHeight -
        document.getElementById('page-header').offsetHeight -
        document.getElementById('page-footer').offsetHeight
      }px`;
      window.addEventListener('resize', () => {
        this.minHeight = `${
          document.documentElement.clientHeight -
          document.getElementById('page-header').offsetHeight -
          document.getElementById('page-footer').offsetHeight
        }px`;
      });
    },
    methods: {
      handleVisable(visable) {
        this.$emit('update:open', visable);
      },
      // 转为PDF
      getObjectURL(file) {
        let url = null;
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          try {
            url = window.webkitURL.createObjectURL(file);
          } catch (error) {
            console.error(error);
          }
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          try {
            url = window.URL.createObjectURL(file);
          } catch (error) {
            console.error(error);
          }
        }
        return url;
      },
      // 打印PDF
      handlePrint() {
        this.$refs.pdf.printPDF();
      },
      // 下载PDF
      handleDownload() {
        if (this.isShowPDFDownloadProgress) return;
        this.isShowPDFDownloadProgress = true;
        const blob = new Blob([this.downloadPdfUrl], {
          type: 'application/pdf',
        });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.download = 'Membership Details';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          this.isShowPDFDownloadProgress = false;
        }, 3000);
      },
    },
    watch: {
      // open(val) {
      //   if (val) {
      //     this.$nextTick(() => {
      //       document.body.appendChild(this.$refs.modalMask);
      //     });
      //   } else {
      //     document.body.removeChild(this.$refs.modalMask);
      //   }
      // },
      pdfUrl: {
        handler(newval) {
          this.url = this.getObjectURL(newval);
          this.downloadPdfUrl = newval;
        },
      },
      open: {
        handler(val) {
          if (!val) {
            this.$refs.pdf.destroyPDF();
          }
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  .modal-mask {
    @include wh(100%, 100%);
    background-color: #f5f7f8;
    // position: fixed;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // left: 0;
    // z-index: 999;
    // background-color: rgba(22, 48, 73, 0.94);

    .modal-containner {
      // position: fixed;
      // top: 15%;
      // left: 50%;
      margin: auto;
      box-sizing: border-box;
      display: flex;
      gap: 26px;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 48.5vw;
      padding: 50px 72px 38px;
      background-color: #f5f7f8;
      border-radius: 10px;
      // transform: translateX(-50%);

      .modal-header {
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .modal-close {
          width: 14px;
          height: 24px;
          cursor: pointer;
        }

        .modal-footer {
          width: 100%;
          display: flex;
          gap: 24px;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;

          .modal-print-btn {
            cursor: pointer;
            width: fit-content;
            padding: 0 32px;
            height: 48px;
            background-color: #c29d5c;
            color: #ffffff;
            @include font($size: 14px, $weight: 500);
            border-radius: 5px;
          }
          .modal-download-btn {
            cursor: pointer;
            width: fit-content;
            padding: 0 32px;
            height: 48px;
            background-color: #f5f7f8;
            border: solid 1px #163049;
            color: #163049;
            @include font($size: 14px, $weight: 500);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 20px;
              height: 20px;
              margin-right: 5px;
            }

            span {
              line-height: 20px;
            }
          }
        }
      }

      .modal-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        @include font($size: 18px, $weight: 400);
        text-align: center;
        line-height: 28px;
        color: #01194d;
        flex-direction: column;

        .description {
          margin-bottom: 30px;
        }

        .pdf-wrap {
          width: 80%;

          .pdf {
            min-height: 600px;
            background: #fff;
            box-shadow: 0 20px 40px -8px rgba(16, 24, 40, 0.1);
            border: solid 1px #d8dee1;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .modal-mask {
      .modal-containner {
        width: 90%;
        padding: 30px 20px 30px;

        .modal-header {
          width: 100%;
          .modal-close {
            width: 12px;
            height: 22px;
          }

          .modal-footer {
            gap: 12px;
            .modal-print-btn {
              height: 32px;
              padding: 0 24px;
              @include font($size: 12px, $weight: 500);
            }
            .modal-download-btn {
              height: 32px;
              padding: 0 24px;
              @include font($size: 12px, $weight: 500);
            }
          }
        }

        .modal-content {
          @include font($size: 12px, $weight: 400);
          line-height: 22px;

          .description {
            margin-bottom: 15px;
          }

          .pdf-wrap {
            width: 100%;

            .pdf {
              min-height: unset;
            }

            @include scroll-bar(5px);
          }
        }
      }
    }
  }
</style>
